import { CampaignAPI, SegmentAPI } from "generated-api"
import { normalizeSync } from "normalize-diacritics"
import { checkIfSessionIsOrWillExpired } from "user/tools/common"
import { IAudience, IAudienceAssociation, IAudienceRepository, ICampaignAudienceAddParams } from "./model"

export const audienceRPO: IAudienceRepository = {
  getAllExternalSegments(): Promise<IAudience[]> {
    return new Promise<IAudience[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        SegmentAPI.getApiSegmentExternalList(undefined, undefined, undefined, "starts_with", undefined, undefined, 4)
          .then(response => {
            // response = getFakeAudiences()
            resolve(
              response.map(a => ({
                ...a,
                agencyName: a.agency?.name || "",
                dmpName: a.dmp?.name || "",
                normalizedName: a.name ? normalizeSync(a.name).toLowerCase() : ""
              }))
            )
          })
          .catch((error: any) => {
            console.error("Server error while getting all external-segments", error)
            reject("external-segment.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all audiences", ex)
        reject("external-segment.get.all.error.unexpected")
      }
    })
  },
  getCampaignExternalSegment(campaignId: number): Promise<IAudienceAssociation[]> {
    return new Promise<IAudienceAssociation[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.getApiCampaignSegmentExternalList(campaignId)
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while getting all campaign's external-segments", error)
            reject("external-segment.campaign.get.all.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while getting all campaign's external-segments", ex)
        reject("external-segment.campaign.get.all.error.unexpected")
      }
    })
  },
  addCampaignExternalSegment(params: ICampaignAudienceAddParams): Promise<IAudienceAssociation> {
    return new Promise<IAudienceAssociation>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignSegmentExternal(params)
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while adding campaign external-segment", error)
            reject("external-segment.campaign.add.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while adding campaign external-segment", ex)
        reject("external-segment.campaign.add.error.unexpected")
      }
    })
  },
  setCampaignExternalSegments(
    campaignId: number,
    params: ICampaignAudienceAddParams[]
  ): Promise<IAudienceAssociation[]> {
    return new Promise<IAudienceAssociation[]>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.postApiCampaignSegmentExternalList(campaignId, params)
          .then(response => resolve(response))
          .catch((error: any) => {
            console.error("Server error while settings campaign external segments (audience)", error)
            reject("external-segment.set.error.server")
          })
      } catch (ex) {
        console.error("Server error while settings campaign external segments (audience)", ex)
        reject("external-segment.set.error.unexpected")
      }
    })
  },
  deleteCampaignExternalSegment(campaignId: number, audienceAssociationId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        checkIfSessionIsOrWillExpired()
        CampaignAPI.deleteApiCampaignSegmentExternal(campaignId, audienceAssociationId)
          .then(() => resolve())
          .catch((error: any) => {
            console.error("Server error while deleting campaign external-segment", error)
            reject("external-segment.campaign.delete.error.server")
          })
      } catch (ex) {
        console.error("Unexpected error while deleting campaign external-segment", ex)
        reject("external-segment.campaign.delete.error.unexpected")
      }
    })
  }
}
